/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable eqeqeq */
import {
  IShareData,
  ValueSelect,
  CameraView,
  DataStorageTable,
  ShareData,
} from "./isharedata";

import { Node, NodeModel, NodeType, _corefiletypes } from "./hsbcad-model";
import { IDataDefinition } from "./idata-definition";
import { MongoDBObjectID } from "./mongoutils";
import { DataStoreType, HsbProject } from "./hsb-project";
import { NodeDataStorage } from "./iproject-db";
import { HsbModelAPIBackEndService } from "./hsb-modelapibackend.service";

import { IShareSessionBase } from "./IShareSessionBase";

export class NodeLoaderService {
  _loadedfiles;
  _numberofNotestoLoad;
  _commpackages;
  _baseurl;
  _datastoreUrl;
  referenceLookup: any;
  //_access_token;
  _credentials!: IShareSessionBase;
  hsbModelAPIBackService!: HsbModelAPIBackEndService;

  initialize(baseurl, credentials: IShareSessionBase) {
    this._loadedfiles = [];
    this._numberofNotestoLoad = [];
    this._commpackages = [];
    this._baseurl = baseurl;
    this._datastoreUrl = "/api/v2/efs/datastore";
    this._credentials = credentials;
    this.hsbModelAPIBackService = new HsbModelAPIBackEndService(
      this._credentials,
      this._baseurl
    );
  }

  CreateDefinitionOutput(dataDefinition, inputData, outputData) {
    let self = this;

    dataDefinition.forEach((field) => {
      let tabledata = inputData[field.columnDef];

      if (tabledata != undefined) {
        if (field.type == "select") {
          tabledata = {
            value: tabledata["value"],
            type: field.type,
            key: tabledata["key"],
          };
        } else if (field.type == "array") {
          if (field.propertySet) {
            if (!Array.isArray(tabledata)) return;
            outputData[field.columnDef] = [];
            tabledata.forEach((data) => {
              let newObject = {};
              outputData[field.columnDef].push(newObject);
              return self.CreateDefinitionOutput(
                field.propertySet,
                data,
                newObject
              );
            });
            return;
          } else {
            outputData[field.columnDef] = [];
            tabledata.forEach((data) => {
              outputData[field.columnDef].push(data);
            });
            return;
          }
        } else if (field.type == "propertySet") {
          outputData[field.columnDef] = {};
          return self.CreateDefinitionOutput(
            field.propertySet,
            tabledata,
            outputData[field.columnDef]
          );
        } else {
          tabledata = { value: tabledata, type: field.type };
        }

        if (field.dataName) {
          outputData[field.dataName] = tabledata;
        } else {
          outputData[field.columnDef] = tabledata;
        }
      }
    });
  }

  CreateDefinitionInputDates(dataDefinition, inputData, outputData) {
    dataDefinition.forEach((field) => {
      let tabledata = inputData[field.columnDef];

      if (tabledata) {
        outputData[field.columnDef] = tabledata;
      }
    });
  }

  CreateDefinitionInputProperties(dataDefinition, inputData, outputData) {
    let self = this;

    dataDefinition.forEach((field) => {
      let tabledata = inputData[field.columnDef];
      if (field.dataName) {
        tabledata = inputData[field.dataName];
      }

      if (tabledata != undefined) {
        if (field.type == "select") {
          let selectData: ValueSelect = new ValueSelect(
            tabledata["key"],
            tabledata["value"]
          );
          tabledata = selectData;
        } else if (field.type == "array") {
          if (field.propertySet) {
            if (!Array.isArray(tabledata)) return;
            outputData[field.columnDef] = [];
            tabledata.forEach((data) => {
              if (field.class != null) {
                let newObject = field.class.clone();
                outputData[field.columnDef].push(newObject);
                return self.CreateDefinitionInputProperties(
                  field.propertySet,
                  data,
                  newObject
                );
              } else {
                let newObject = {};
                outputData[field.columnDef].push(newObject);
                return self.CreateDefinitionInputProperties(
                  field.propertySet,
                  data,
                  newObject
                );
              }
            });
            return;
          } else {
            outputData[field.columnDef] = [];
            tabledata.forEach(() => {
              outputData[field.columnDef] = [];
              tabledata.forEach((data) => {
                outputData[field.columnDef].push(data);
              });
            });
            return;
          }
        } else if (field.type == "propertySet") {
          outputData[field.columnDef] = {};
          return self.CreateDefinitionInputProperties(
            field.propertySet,
            tabledata,
            outputData[field.columnDef]
          );
        } else {
          tabledata = tabledata["value"];
        }

        outputData[field.columnDef] = tabledata;
      }
    });
  }

  updateModelNode(
    dataDefinition: Array<IDataDefinition>,
    shareData: IShareData
  ) {
    let self = this;

    var promise = new Promise(function (resolve, reject) {
      //if (!shareData.hsbProject) return;

      let hsbProject = shareData.hsbProject;
      let nodeModel = hsbProject ? hsbProject.nodeModel : null;
      let update = shareData.modelNode ? "PUT" : "POST";
      let metadata: any = {};
      let pathid = '';

      if (update == "POST") {
        let nodedata = {
          itemtype: shareData.itemType,
          properties: {},
        };

        metadata.data = nodedata;
        metadata.fileinfo = { path: ".modelnode" };
        if (shareData.hsbProject) {
          metadata.path = hsbProject.datastoreFolder + "/modelnodes/";
        }
      } else {
        metadata = shareData.modelNode.metadata;
        pathid = shareData.modelNode.pathid;
      }

      if (dataDefinition.length > 0) {
        self.CreateDefinitionOutput(
          dataDefinition,
          shareData.data,
          metadata.data.properties
        );
      }

      if (shareData.entityNode && shareData.entityNode.entity) {
        delete metadata.data.references;
        metadata.data.references = [];
        let modeNodesToAdd = [];

        self.addReferenceNode(metadata, shareData.entityNode, modeNodesToAdd);

        if (modeNodesToAdd.length > 0) {
          self
            .addMetaFileDataDB(modeNodesToAdd, "POST", shareData)
            .then(function () {})
            .catch(function () {
              return reject("failed to add node to DB");
            });
        }
      } else if (shareData.references && shareData.references.length > 0) {
        if (metadata.data.references) {
          var existingReferences = metadata.data.references.map(
            (reference) => reference
          );
          if (nodeModel) {
            existingReferences.forEach((reference) => {
              var refnode = nodeModel!.findGroupChildNodeByPathId(
                nodeModel!.ItemsRoot,
                reference
              );

              if (refnode) {
                if (
                  refnode.metadata.data.itemtype == "hsbshare.geomreference" &&
                  refnode.metadata.data.references &&
                  refnode.metadata.data.references.length == 1
                ) {
                  // To get the project mode we need to query the reference in this geomreference node.
                  let ref = refnode.metadata.data.references[0];

                  let projectModelNode = nodeModel!.findGroupChildNodeByPathId(
                    nodeModel!.ItemsRoot,
                    ref
                  );
                  if (
                    projectModelNode &&
                    projectModelNode.metadata.data.properties &&
                    projectModelNode.metadata.data.properties["modelId"]
                  ) {
                    let modelId =
                      projectModelNode.metadata.data.properties["modelId"]
                        .value;

                    if (hsbProject.HsbModels[modelId]) {
                      // Only process existing references that point to loaded models - if models aren't loaded leave the reference in the node data.
                      var index = metadata.data.references.indexOf(reference);
                      if (index > -1) {
                        metadata.data.references.splice(index, 1);
                      }
                    }
                  }
                }
              }
            });
          }
        }

        //delete metadata.data.references;
        if (!metadata.data.references) {
          metadata.data.references = [];
        }

        if (shareData.references.length > 0) {
          if (hsbProject.NodeStorage == DataStoreType.Database) {
            let modeNodesToAdd = [];

            shareData.references.forEach((ref) => {
              self.addReferenceNode(metadata, ref.modelNode, modeNodesToAdd);
            });

            if (modeNodesToAdd.length > 0) {
              self
                .addMetaFileDataDB(modeNodesToAdd, "POST", shareData)
                .then(function () {})
                .catch(function (err) {
                  console.error("failed to add node to DB", err);
                  return reject("failed to add node to DB");
                });
            }
          } else {
            metadata.data.references = shareData.references.map((reference) =>
              reference.getReferenceData()
            );
          }
        }
      }

      let nodeStorage = DataStoreType.Database;

      if (nodeStorage == DataStoreType.Database) {
        // Set all the custom data here.
        if (shareData.cameraView && shareData.cameraView.view) {
          delete metadata.data.data;
          metadata.data.data = {};
          metadata.data.data.cameraView = shareData.cameraView.view;
        }

        if (shareData.modelReferences)
          metadata.data.modelReferences = shareData.modelReferences;

        if (!metadata.data._id) {
          metadata.data._id = MongoDBObjectID.newId();
          update = "POST";
        } else {
          update = "PUT";
        }

        if (hsbProject) {
          metadata.data.projectId = hsbProject.projectID;
        }

        if (shareData.storageTable == DataStorageTable.Team) {
          delete metadata.data.projectId;
          metadata.data.teamID = shareData.teamID;
        } else if (shareData.storageTable == DataStorageTable.User) {
          delete metadata.data.projectId;
          metadata.data.userid = shareData.userId;
        }

        delete metadata.fileinfo;
        delete metadata.path;

        self
          .addMetaFileDataDB(metadata.data, update, shareData)
          .then(function (fileStat: any) {
            pathid = fileStat._id;
            if (nodeModel) {
              self.UpdateDbNode(nodeModel, metadata.data);
              // Get the added node out of nodemodel
              shareData.modelNode = nodeModel.findGroupChildNodeByPathId(
                nodeModel.ItemsRoot,
                pathid
              );
            }
            resolve(null);
          })
          .catch(function (err) {
            console.error("failed to create Node in DB", err);
            reject("failed to create Node in DB");
          });
      }
    }).catch((error) => {
      console.error("Error loading projects: " + error);
      return Promise.reject(error);
    });

    return promise;
  }

  addReferenceNode(metadata, refModelNode, modeNodesToAdd) {
    let self = this;

    if (refModelNode.entity) {
      let nodeModel = refModelNode.nodeModel;
      let hsbProject = refModelNode.nodeModel.hsbProject;

      // Special geom reference case for the DB node.
      // We need to create reference node that references the project model that this entity belongs to.
      // Find check this geom reference node doesn't already exist
      let geomrefs = nodeModel.getNodesMetadataIdByItemType(
        hsbProject.nodeModel.ItemsRoot,
        "hsbshare.geomreference"
      );
      var handle = refModelNode.entity.handle;
      let found = geomrefs.filter(
        (node) =>
          node.metadata.data.properties &&
          node.metadata.data.properties["referenceId"] &&
          node.metadata.data.properties["referenceId"].value == handle
      )[0];
      if (!found) {
        let newNode: any = {
          itemtype: "hsbshare.geomreference",
          properties: {},
          references: [],
          documents: [],
          projectId: hsbProject.projectID,
        };

        newNode.properties["referenceId"] = { value: handle, type: "string" };
        if (refModelNode.entity.ifcid) {
          newNode.properties["ifcId"] = {
            value: refModelNode.entity.ifcid,
            type: "string",
          };
        }

        newNode._id = MongoDBObjectID.newId();
        newNode.references.push(refModelNode.hsbmodel.Node.pathid);
        metadata.data.references.push(newNode._id);

        self.UpdateDbNode(nodeModel, newNode);
        // Get the added node out of nodemodel
        modeNodesToAdd.push(newNode);
      } else {
        metadata.data.references.push(found.pathid);
      }
    } else {
      metadata.data.references.push(refModelNode.pathid);
    }
  }

  updateData(dataDefinition: Array<IDataDefinition>, data: IShareData) {
    let modelNodeItems: Node[] = [];
    let self = this;
    // If project supplied check if we have reference data.
    if (data.hsbProject) {
      modelNodeItems = data.hsbProject.nodeModel.getChildNodes(
        data.hsbProject.nodeModel.ItemsRoot
      );
    }

    let exists: any;

    if (data.entityNode) {
      if (modelNodeItems.length > 0 && data.entityNode.entity) {
        exists = modelNodeItems.find(function (e) {
          var references = data.hsbProject.nodeModel.getShareReferences(e);
          return references.find((reference) => {
            return reference?.modelNode?.entity == data.entityNode.entity;
          });
        });
      }
    } else {
      exists = data.modelNode;
    }

    if (exists) {
      data.modelNode = exists;
      let inputData = data.data;

      if (dataDefinition.length > 0) {
        self.CreateDefinitionInputProperties(
          dataDefinition,
          exists.metadata.data.properties,
          inputData
        );
      }

      if (data.hsbProject) {
        data.references = data.hsbProject.nodeModel.getShareReferences(
          data.modelNode
        );

        if (data.hsbProject.NodeStorage == DataStoreType.Database) {
          if (exists?.metadata?.data?.data?.cameraView) {
            data.cameraView = new CameraView(
              exists.metadata.data.data.cameraView
            );
          }
        } else {
          if (exists.metadata.data.cameraView) {
            data.cameraView = new CameraView(exists.metadata.data.cameraView);
          }
        }
      }
    }
  }

  addCustomNodeTree(customnodes, nodemodel, rootfolder, root) {
    function addCustomNode(customnode) {
      var fileinfo = customnode;
      var addfilenode = false;
      if (customnode.stat) {
        fileinfo = customnode.stat;
        addfilenode = true;
      }

      nodemodel.createCustomNode(root, fileinfo, rootfolder, addfilenode);
    }

    if (Array.isArray(customnodes)) {
      customnodes.forEach((customnode) => {
        addCustomNode(customnode);
      });
    }
  }
  addNodeMetadata(metadata, nodemodel) {
    nodemodel.addMetadata(nodemodel.root, metadata);
  }
  getFile(filepath): Promise<any> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .getFile(filepath)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  getFileUrl(url): Promise<string> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .getFileUrl(url)
        .then(function (data: string) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // WLM Redundant
  getMetaFiles(rootfolder, searchfile, returndata, callbackloadeddata) {
    let _self = this;

    var datarequest: any = { folder: rootfolder, filename: searchfile };

    let pattern;

    // If already a "pattern" down create a new pattern.
    if (searchfile[0] == "*") {
      pattern = searchfile;
    } else {
      pattern = "**/(*" + searchfile + ")";
    }
    datarequest = { folder: rootfolder, pattern: pattern };

    // WLM jq
    // $.ajax({
    //     url: _self._baseurl + _self._datastoreUrl + '/getFiles',
    //     type: 'GET',
    //     async: true,
    //     data: datarequest,
    //     dataType: 'json',
    //     contentType: 'application/json',
    //     headers: { "x-access-token": _self._credentials.token },
    //     success: function (foundfiles) {

    //         callbackloadeddata(foundfiles, returndata);
    //     },
    //     error: function () {
    //     }
    // });
  }

  UpdateDbNode(nodemodel, nodeData) {
    let dbNode: Node | null = null;

    if (nodeData._id) {
      dbNode = nodemodel.findGroupChildNodeByPathId(
        nodemodel.ItemsRoot,
        nodeData._id
      );

      if (dbNode) {
        dbNode.metadata.data = nodeData;
      }
    }

    if (!dbNode) {
      var dbNodesRoot = nodemodel.findOriginNode(
        nodemodel.root,
        NodeType.DbNodes
      );

      let dbNewNode = nodemodel.createNode(nodeData._id, dbNodesRoot);
      nodemodel.addChildNode(dbNodesRoot, dbNewNode);

      dbNewNode.metadata.data = nodeData;
      dbNewNode.pathid = nodeData._id;
    }
  }

  appendNodeModel(foundfiles, nodemodel) {
    var _self = this;

    if (nodemodel.hsbProject.NodeStorage == DataStoreType.Database) {
      foundfiles.forEach(function (file) {
        // Ensure ALL node itemtype are namespace - Any lecacy nodes we need to add 'hsbshare'
        if (file && file.itemtype) {
          let split = file.itemtype.split(".");

          if (split.length == 1) {
            if (
              file.itemtype == "area" ||
              file.itemtype == "package" ||
              file.itemtype == "element" ||
              file.itemtype == "truck" ||
              file.itemtype == "project"
            ) {
              // For now - don't do this change.
              file.itemtype = "hsbshare." + file.itemtype;
            } else {
              file.itemtype = "hsbshare." + file.itemtype;
            }
          }
        }
        _self.UpdateDbNode(nodemodel, file);
      });
    }
  }

  createModel(foundfiles, nodemodel, rootfolder, buildproject = undefined) {
    var _self = this;

    if (nodemodel.hsbProject.NodeStorage == DataStoreType.Database) {
      var itemsroot = nodemodel.findOriginNode(nodemodel.root, NodeType.Items);

      var dbNodesRoot = nodemodel.createNode("dbnodes", itemsroot);
      dbNodesRoot.metadata.data = { origin: "datastore", itemtype: "dbnodes" };
      nodemodel.addChildNode(itemsroot, dbNodesRoot);

      foundfiles.forEach(function (file) {
        // Ensure ALL node itemtype are namespace - Any lecacy nodes we need to add 'hsbshare'
        if (file && file.itemtype) {
          let split = file.itemtype.split(".");

          if (split.length == 1) {
            if (
              file.itemtype == "area" ||
              file.itemtype == "package" ||
              file.itemtype == "element" ||
              file.itemtype == "truck" ||
              file.itemtype == "project"
            ) {
              // For now - don't do this change.
              file.itemtype = "hsbshare." + file.itemtype;
            } else {
              file.itemtype = "hsbshare." + file.itemtype;
            }
          }
        }

        _self.UpdateDbNode(nodemodel, file);
      });

      let checkRedundantNodes = true;

      if (checkRedundantNodes) {
        // Check and remove any redundent hsbshare.geomrefence nodes.
        let geomRefs = nodemodel.getNodesMetadataIdByItemType(
          nodemodel.ItemsRoot,
          "hsbshare.geomreference"
        );
        let nodeHash = {};

        geomRefs.forEach((geomRefNode) => {
          nodeHash[geomRefNode.pathid] = geomRefNode;
        });

        //let allNodes = nodemodel.getChildNodes(dbNodesRoot.children);
        let unReferencedNodes: Node[] = [];

        geomRefs.forEach((geomRefNode) => {
          let nodeIsReferenced = false;
          dbNodesRoot.children.forEach((node) => {
            if (node != geomRefNode) {
              node.metadata.data.references.forEach((reference) => {
                //let refNode = nodemodel.findGroupChildNodeByPathId(nodemodel.ItemsRoot, reference);
                let refNode = nodeHash[reference];

                if (!nodeIsReferenced && refNode == geomRefNode) {
                  nodeIsReferenced = true;
                }
              });
            }
          });

          if (!nodeIsReferenced) {
            let searchResult = unReferencedNodes.filter((node) => {
              return geomRefNode == node;
            })[0];

            if (!searchResult) {
              unReferencedNodes.push(geomRefNode);
            }
          }
        });

        if (unReferencedNodes.length > 0) {
          _self
            .deleteItemDataDB(nodemodel, unReferencedNodes)
            .then(function () {})
            .catch(function () {});
        }
      }
    } else {
      var configroot = nodemodel.findGroupChildNode(nodemodel.root, "config");

      if (configroot && foundfiles && foundfiles.length > 0) {
        var itemsroot = nodemodel.findOriginNode(
          nodemodel.root,
          NodeType.Items
        );

        foundfiles.forEach(function (file) {
          // Ensure ALL node itemtype are namespace - Any lecacy nodes we need to add 'hsbshare'
          if (file.data && file.data.itemtype) {
            let split = file.data.itemtype.split(".");

            if (split.length == 1) {
              if (
                file.data.itemtype == "area" ||
                file.data.itemtype == "package" ||
                file.data.itemtype == "element" ||
                file.data.itemtype == "truck" ||
                file.data.itemtype == "project"
              ) {
                // For now - don't do this change.
                file.data.itemtype = "hsbshare." + file.data.itemtype;
              } else {
                file.data.itemtype = "hsbshare." + file.data.itemtype;
              }
            }
          }

          file.fileinfo = { path: file.path, stat: file.filestat };
          delete file.filestat;
        });

        var configfiles = foundfiles.filter((e) => {
          var filename = e.path.split("/").pop();
          return filename == ".hsbshareproject" || filename == ".configuration";
        });
        var itemsfiles = foundfiles.filter((e) => {
          var filename = e.path.split("/").pop();

          if (filename == ".hsbsharemodel") {
            e.data.itemtype = e.data.nodetype;
          }

          return (
            filename == ".root" ||
            filename == ".node" ||
            filename == ".modelnode" ||
            filename == ".hsbsharemodel"
          );
        });

        configfiles.sort(function (a, b) {
          return a.path.split("/") > b.path.split("/");
        });
        itemsfiles.sort(function (a, b) {
          return a.path.split("/") > b.path.split("/");
        });

        // Now build the model.
        var additemsToModel = function (items, root) {
          _self.addCustomNodeTree(items, nodemodel, rootfolder, root);
        };

        delete configroot.children;
        delete itemsroot.children;

        additemsToModel(configfiles, configroot);
        additemsToModel(itemsfiles, itemsroot);
      }
    }
  }

  getCustomNodesWithContentArray(
    access_token,
    projectFolders,
    searchfiles
  ): Promise<Array<any>> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .getCustomNodesWithContentArray(projectFolders, searchfiles)
        .then(function (data: Array<any>) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  loadProjectsData(
    access_token,
    projectFolders,
    searchfiles
  ): Promise<Array<any>> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      if (projectFolders.length == 0) {
        return resolve([]);
      }

      _self
        .getCustomNodesWithContentArray(
          access_token,
          projectFolders,
          searchfiles
        )
        .then(function (data: Array<any>) {
          let returnData: any[] = [];

          projectFolders.forEach((folder) => {
            let searchResult = data.filter((datafolder) => {
              return datafolder.path == folder;
            })[0];

            let projectData: any = {};
            returnData.push(projectData);

            projectData.path = folder;
            projectData.data = [];
            projectData.dataStore = DataStoreType.EFS;

            if (searchResult) {
              projectData.data = searchResult.data;
            }
          });

          return resolve(returnData);
        })
        .catch(function (err) {
          return reject(err);
        });
    });
  }
  addtoDocList(hsbProject, filepath, filestat) {
    var filename = filepath.split("/").pop();
    var ext = filename.split(".").pop();
    if (!_corefiletypes[filename]) {
      var exists = hsbProject.docFiles.filter(function (e) {
        return e.path == filepath;
      })[0];

      if (!exists) {
        let newDoc = {
          path: filepath,
          filename: filename,
          ext: ext,
          filestat: filestat,
        };
        hsbProject.docFiles.push(newDoc);

        return newDoc;
      }
    }
  }

  removefromDocList(hsbProject, filepath) {
    var exists = hsbProject.docFiles.filter(function (e) {
      return e.path == filepath;
    })[0];

    if (exists) {
      var index = hsbProject.docFiles.indexOf(exists);
      hsbProject.docFiles.splice(index, 1);
    }
  }

  loadAllDocs(hsbProject) {
    let _self = this;

    return new Promise(function (resolve) {
      var onallfilesFound = function (foundfiles) {
        hsbProject.docFiles = [];

        foundfiles.forEach(function (file) {
          if (file.is_dir) {
            return;
          }

          _self.addtoDocList(hsbProject, file.path, file.filestat);
        });

        resolve(true);
      };

      _self.loadMetaFileData(
        hsbProject.datastoreFolder,
        "**",
        null,
        onallfilesFound
      );
    });
  }
  loadMetaFileData(rootfolder, filename, returndata, callbackloadeddata) {
    this.getMetaFiles(rootfolder, filename, returndata, callbackloadeddata);
  }

  addMetaFileData(metadata, requestType) {
    let _self = this;

    var promise = new Promise(function (resolve, reject) {
      if (metadata.data && metadata.fileinfo) {
        let jsondata: any = {
          filedata: metadata.data,
          filename: metadata.fileinfo.path,
        };

        if (metadata.path) {
          jsondata.path = metadata.path;
        }
        // WLM jq
        // $.ajax({
        //     url: _self._baseurl + _self._datastoreUrl + '/modelnode',
        //     type: requestType,
        //     async: true,
        //     contentType: 'application/json',
        //     dataType: 'json',
        //     data: JSON.stringify(jsondata),
        //     headers: { "x-access-token": _self._credentials.token },
        //     success: function (response) {

        //         metadata.fileinfo.stat = response.filestat;

        //         return resolve(response);
        //     },
        //     error: function () {
        //         return reject();
        //     }
        // });
      } else {
        return reject(
          "NodeLoaderService.addMetaFileData(): No metadata provided!"
        );
      }
    });

    return promise;
  }

  previewFile(filename) {
    let self = this;

    let url =
      self._baseurl +
      self._datastoreUrl +
      "/getFile?path=" +
      filename +
      "&access_token=" +
      self._credentials.token;
    window.open(url);
    return;
  }
  deleteModelNode(shareData: IShareData) {
    let self = this;

    return new Promise(function (resolve, reject) {
      if (!shareData.modelNode) {
        return reject("invalid data to delete");
      }
      let nodeModel: any = null;
      if (shareData.hsbProject) {
        nodeModel = shareData.hsbProject.nodeModel;
      }
      let modelNode = shareData.modelNode;

      self.deleteIShareData(shareData, nodeModel, modelNode).then(
        function () {
          resolve("success");
        },
        function (error) {
          return reject(error);
        }
      );
    });
  }

  deleteIShareNodes(shareNodes: Array<IShareData>) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let urlGroups = [];
      // Group by base URL
      shareNodes.forEach((shareData) => {
        var route = self._baseurl + shareData.getStorageBaseUrl() + "/array";
        if (!urlGroups[route]) {
          urlGroups[route] = [];
        }
        urlGroups[route].push(shareData);
      });

      let promisefunctions: Promise<any>[] = [];
      Object.keys(urlGroups).forEach((key) => {
        let urlGroup = urlGroups[key];
        let nodes = urlGroup.map((e) => {
          return e.modelNode;
        });
        promisefunctions.push(
          self.deleteIShareData(
            urlGroup[0],
            urlGroup[0].hsbProject.nodeModel,
            nodes
          )
        );
      });

      Promise.all(promisefunctions)
        .then(function () {
          resolve("success");
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  deleteIShareData(shareData: IShareData, nodemodel, nodes): Promise<any> {
    let _self = this;
    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .deleteIShareData(shareData, nodemodel, nodes)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  deleteItemDataEFS(nodemodel, nodedata) {
    let _self = this;
    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .deleteItemDataEFS(nodemodel, nodedata)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  deleteItemData(nodemodel, nodedata) {
    let self = this;

    return new Promise(function (resolve, reject) {
      if (nodemodel.hsbProject.NodeStorage == DataStoreType.EFS) {
        self.deleteItemDataEFS(nodemodel, nodedata).then(
          function () {
            resolve("success");
          },
          function (error) {
            return reject(error);
          }
        );
      } else {
        self.deleteItemDataDB(nodemodel, nodedata).then(
          function () {
            resolve("success");
          },
          function (error) {
            return reject(error);
          }
        );
      }
    });
  }

  deleteItemDataDB(nodemodel, nodes) {
    let _self = this;
    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .deleteItemDataDB(nodemodel, nodes)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  deleteItemPath(path) {
    let _self = this;
    var promise = new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .deleteItemPath(path)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addFiles(hsbProject, files, folder) {
    let _self = this;
    var promise = new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .addFiles(hsbProject, files, folder)
        .then(function (data: any) {
          let addedDocs: any[] = [];
          // If successfull - append these file to the docfiles list.
          files.forEach(function (file) {
            let added = _self.addtoDocList(hsbProject, folder + file.name, {
              ctime: file.file.lastModifiedDate,
            });
            if (added) {
              addedDocs.push(added);
            }
          });
          resolve(addedDocs);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }
  addFile(fileName, fileData, onProgressEvent?) {
    let _self = this;
    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .addFile(fileName, fileData, onProgressEvent)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  makeFolder(path) {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .makeFolder(path)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  copyFileorFolder(pathfrom, pathto) {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .copyFileorFolder(pathfrom, pathto)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  setNodeDataStorage(projectID, nodeDataStorage: NodeDataStorage) {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .setNodeDataStorage(projectID, nodeDataStorage)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  getCustomNodesWithContentArrayDB(
    tableIds,
    storageTable: DataStorageTable = DataStorageTable.Project
  ): Promise<Array<any>> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .getCustomNodesWithContentArrayDB(tableIds, storageTable)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  addMetaFileDataDB(nodes, requestType, shareData: IShareData) {
    let _self = this;

    var promise = new Promise(function (resolve, reject) {
      _self.hsbModelAPIBackService
        .addMetaFileDataDB(nodes, requestType, shareData)
        .then(function (data: any) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  createNodeModel(hsbProject) {
    var nodeModel = new NodeModel("root", "root", hsbProject);
    var rootnode = nodeModel.root;

    // Create main data and config node - these will be the main root node of the trees
    var node = nodeModel.createNode("data", rootnode);
    nodeModel.addChildNode(rootnode, node);

    // Create config node of data.
    var node = nodeModel.createNode("config", rootnode);
    nodeModel.addChildNode(rootnode, node);

    var dataroot = nodeModel.findGroupChildNode(nodeModel.root, "data");

    if (dataroot) {
      // Create model root nodes.
      var datamodelroot = nodeModel.createNode(NodeType.Items, dataroot);
      nodeModel.ItemsRoot = datamodelroot;
      datamodelroot.metadata.data = {
        origin: "datastore",
        itemtype: NodeType.Items,
      };
      nodeModel.addChildNode(dataroot, datamodelroot);

      datamodelroot = nodeModel.createNode(NodeType.Model, dataroot);
      datamodelroot.metadata.data = {
        origin: "datastore",
        itemtype: NodeType.Model,
      };
      nodeModel.ModelRoot = datamodelroot;
      nodeModel.addChildNode(dataroot, datamodelroot);
    }

    return nodeModel;
  }

  loadProjectsDataDB(
    access_token,
    projectFolders,
    searchfiles
  ): Promise<Array<any>> {
    let _self = this;

    return new Promise(function (resolve, reject) {
      if (projectFolders.length == 0) {
        return resolve([]);
      }

      _self
        .getCustomNodesWithContentArrayDB(projectFolders)
        .then(function (data: Array<any>) {
          let returnData: any[] = [];

          projectFolders.forEach((folder) => {
            let searchResult = data.filter((datafolder) => {
              return datafolder.path == folder;
            })[0];

            let projectData: any = {};
            returnData.push(projectData);

            projectData.path = folder;
            projectData.data = [];
            projectData.dataStore = DataStoreType.Database;

            if (searchResult) {
              projectData.data = searchResult.data;
            }
          });

          //let returnData = data.map((projectFolder) => {
          //   return { data: projectFolder.data, path: projectFolder.path, dataStore: DataStoreType.Database};
          //});

          return resolve(returnData);
        })
        .catch(function (err) {
          return reject(err);
        });
    });
  }

  migrateDocuments(hsbProject, nodes) {
    let self = this;

    let promisefunctions: Promise<any>[] = [];

    nodes.forEach((node) => {
      let newNode = node.DBRef;
      if (!newNode) return;

      // Add the documents.
      if (node.docFiles && node.docFiles.length > 0) {
        node.docFiles.forEach((doc) => {
          var promise = new Promise(function (resolve, reject) {
            var filename = doc.path.split("/").pop();
            let newFolder =
              "/projectData/" + hsbProject.projectID + "/" + newNode._id;
            let newPath =
              "/projectData/" +
              hsbProject.projectID +
              "/" +
              newNode._id +
              "/" +
              filename;

            self
              .makeFolder(newFolder)
              .then(function () {
                // We need to copy all files from efs /project/ to efs /projectData
                self
                  .copyFileorFolder(doc.path, newPath)
                  .then(function () {
                    newNode.documents.push({
                      path: newPath,
                      provider: "hsbShare",
                    });
                    return resolve(null);
                  })
                  .catch(function (err) {
                    return reject(err);
                  });
              })
              .catch(function (err) {
                return reject(err);
              });
          });

          promisefunctions.push(promise);
        });
      } else {
        promisefunctions.push(Promise.resolve("success"));
      }
    });

    return Promise.all(promisefunctions);
  }

  createNewDBNodes(hsbProject, nodes) {
    let self = this;

    nodes.forEach((node) => {
      let newNode: any = {};
      if (!node.pathid || !node.metadata.data.itemtype) return;

      if (node.metadata.data.itemtype == NodeType.HsbModel) {
        newNode = {
          itemtype: "hsbshare.projectmodel",
          properties: {},
          documents: [],
        };
        newNode.properties["modelName"] = {
          value: node.metadata.data.modelname,
          type: "string",
        };
        newNode.properties["modelId"] = {
          value: node.metadata.data.modelId,
          type: "string",
        };
        newNode.properties["setName"] = {
          value: node.metadata.data.setname,
          type: "string",
        };
        newNode.properties["revision"] = {
          value: node.metadata.data.revision,
          type: "string",
        };
        newNode.properties["active"] = {
          value: node.metadata.data.active,
          type: "boolean",
        };
      } else {
        let itemTypeSplit = node.metadata.data.itemtype.split(".");
        let itemType = node.metadata.data.itemtype;

        if (itemTypeSplit.length == 1) {
          itemType = "hsbshare." + itemType;
        }

        newNode = { itemtype: itemType, properties: {}, documents: [] };
        if (node.metadata.data.properties) {
          // Dont add old style properties.
          if (Array.isArray(node.metadata.data.properties)) {
          } else {
            newNode.properties = node.metadata.data.properties;
          }
        }
      }

      newNode._id = MongoDBObjectID.newId();
      newNode.projectId = hsbProject.projectID;
      newNode.references = [];

      if (node.metadata.data.cameraView && node.metadata.data.cameraView) {
        newNode.data = {};
        newNode.data.cameraView = node.metadata.data.cameraView;
      }

      if(node.metaData.modelReferences)
        newNode.modelReferences = node.metaData.modelReferences;

      node.DBRef = newNode;

      if (!self.referenceLookup[node.pathid]) {
        self.referenceLookup[node.pathid] = newNode;
      }
    });
  }

  migrateUptoDB(hsbProject) {
    let self = this;
    let shareData = new ShareData(null, hsbProject, "", null, undefined, false);

    return new Promise(function (resolve, reject) {
      self
        .getCustomNodesWithContentArrayDB([hsbProject.projectID])
        .then(async function (data: Array<any>) {
          if (data.length == 1) {
            return reject("project already converted");
          }

          let allNodes = hsbProject.nodeModel.getChildNodes(
            hsbProject.nodeModel.ItemsRoot
          );

          // Convert the existing '.hsbmodelnode' that contain the geometry
          //let hsbMakeModels = hsbProject.nodeModel.getNodesMetadataIdByItemType(hsbProject.nodeModel.root, NodeType.HsbModel);

          self.referenceLookup = {};
          // Now add these nodes to the db.

          self.createNewDBNodes(hsbProject, allNodes);
          self
            .migrateDocuments(hsbProject, allNodes)
            .then(function () {
              let processNodes = {};

              // Now organise all the reference node.
              allNodes.forEach((node) => {
                if (!node.pathid) return;

                let refNodes = node.getReferenceNodes();

                if (!processNodes[node.pathid]) {
                  processNodes[node.pathid] = { node: node };
                }

                refNodes.forEach((refNode) => {
                  if (!processNodes[node.pathid].refNodes) {
                    processNodes[node.pathid].refNodes = {};
                  }

                  if (!processNodes[node.pathid].refNodes[refNode.pathid]) {
                    processNodes[node.pathid].refNodes[refNode.pathid] =
                      refNode;
                  }
                });
              });

              // Process to convert.
              // Convert all node and push to the db - and store each new node in the existing node data.
              // Then iterate around these existing node and resolve the references to these new nodes.
              // First add a hsbshare.geomreference node for each geometry handle node - this is a new node that connects a geometry item with a projectmodel node
              let geomReferences = {};

              Object.keys(processNodes).forEach((key) => {
                let existingNodeRef = processNodes[key];

                let node = existingNodeRef.node;
                let refNodes = existingNodeRef.refNodes;
                let DBRef = node.DBRef;

                if (!refNodes || !DBRef) return;

                Object.keys(refNodes).forEach((key) => {
                  if (key.indexOf("/") != -1) {
                    let geomNode = refNodes[key];

                    if (geomNode.DBRef) {
                      DBRef.references.push(geomNode.DBRef._id);
                    }
                  } else {
                    // Geometry Reference - we need to create a new hsbshare.geomreference node and connect this to the projectmodel.
                    let geomNode = refNodes[key];

                    if (!geomNode.hsbmodel.FilePath) return;
                    let pathid = geomNode.hsbmodel.FilePath.substring(
                      0,
                      geomNode.hsbmodel.FilePath.lastIndexOf("/")
                    );

                    let geomRef = self.referenceLookup[pathid];

                    if (!geomRef) return;

                    let foundRef: any = null;
                    // Check if any geomreference have alittle assign - if so don't create additional ones.
                    Object.keys(geomReferences).forEach((geomKey) => {
                      let handle =
                        geomReferences[geomKey].properties["referenceId"].value;
                      let refId = geomReferences[geomKey].references[0];

                      if (handle == key && refId == geomRef._id) {
                        foundRef = geomReferences[geomKey];
                        return;
                      }
                    });

                    if (foundRef) {
                      geomReferences[foundRef._id] = foundRef;
                      geomNode.DBRef = foundRef;
                    } else {
                      let newNode: any = {
                        itemtype: "hsbshare.geomreference",
                        properties: {},
                        references: [],
                        documents: [],
                        projectId: hsbProject.projectID,
                      };
                      newNode.properties["referenceId"] = {
                        value: key,
                        type: "string",
                      };
                      newNode._id = MongoDBObjectID.newId();
                      newNode.references.push(geomRef._id);
                      geomReferences[newNode._id] = newNode;
                      geomNode.DBRef = newNode;
                    }

                    // Now reference this new node back
                    if (geomNode.DBRef) {
                      DBRef.references.push(geomNode.DBRef._id);
                    }
                  }
                });
              });

              let newNodesUpdate = {};

              // Create a flat hast table of all the converted nodes to pull the database.
              Object.keys(processNodes).forEach((key) => {
                let existingNodeRef = processNodes[key];
                let node = existingNodeRef.node;
                let refNodes = existingNodeRef.refNodes;

                let DBRef = node.DBRef;
                if (!DBRef) return;

                if (!newNodesUpdate[DBRef._id]) {
                  newNodesUpdate[DBRef._id] = DBRef;
                }

                if (!refNodes) return;

                Object.keys(refNodes).forEach((key) => {
                  let geomNode = refNodes[key];
                  if (geomNode.DBRef) {
                    if (!newNodesUpdate[geomNode.DBRef._id]) {
                      newNodesUpdate[geomNode.DBRef._id] = geomNode.DBRef;
                    }
                  }
                });
              });

              // Create array
              let updateNodes = Object.keys(newNodesUpdate).map((key) => {
                return newNodesUpdate[key];
              });

              if (updateNodes.length == 0) {
                return reject("failed to convert project - no Nodes");
              }

              self
                .addMetaFileDataDB(updateNodes, "POST", shareData)
                .then(function () {
                  return resolve("converted project successfully");
                })
                .catch(function () {
                  return reject("failed to convert project");
                });
            })
            .catch(function () {
              return reject("failed to convert project");
            });
        })
        .catch(function () {
          //return reject('failed to load data');
        });
    });
  }

  async getProjectModelNodes(projectID: string): Promise<any> {
    let self = this;
    if (!projectID || projectID.length === 0)
      return Promise.reject(
        "nodeLoaderService::getProjectModelNodes(): String is null or empty"
      );
    return self.hsbModelAPIBackService.getProjectModelNodes(projectID);
  }

  async registerProjectOpened(projectID: string): Promise<any> {
    let self = this;
    if (!projectID || projectID.length === 0)
      return Promise.reject(
        "nodeLoaderService::registerProjectOpened(): String is null or empty"
      );
    return self.hsbModelAPIBackService.registerActivityProjectOpened(projectID);
  }

  migrateDownToEFS(hsbProject) {
    let self = this;

    return new Promise(function (resolve, reject) {
      if (hsbProject.NodeStorage == DataStoreType.EFS) {
        return reject("project already in EFS");
      }

      var dbNodesRoot = hsbProject.nodeModel.findOriginNode(
        hsbProject.nodeModel.ItemsRoot,
        NodeType.DbNodes
      );

      if (!dbNodesRoot || !dbNodesRoot.children) {
        return resolve("project already in EFS");
      }

      let nodes = dbNodesRoot.children;

      self
        .deleteItemDataDB(hsbProject.nodeModel, nodes)
        .then(function () {
          resolve("success");
        })
        .catch(function (err) {
          return reject(err);
        });
    });
  }
}
